import { API_ROOT } from './.env'
import { buildUri } from './index'

const COLLECTIONS = 'collections/'

export const collections = (id = null, params) => {
    return API_ROOT + COLLECTIONS + (id || '') + buildUri(params)
};

export const collectionReport = (id, params) => {
    return API_ROOT + COLLECTIONS + id + '/report' + buildUri(params)
};

export const collectionEntities = (id, params) => collections(id) + '/entities' + buildUri(params);

export const communities = (id = null, params) => {
    return collections(id) + '/communities' + buildUri(params);
}

export const communityChildrens = (collectionId, communitId, params) => {
    return communities(collectionId) + '/' + communitId + '/childrens' + buildUri(params);
}

export const collectionRoles = (id, params) => {
    return API_ROOT + 'collections/' + id + '/roles' + buildUri(params)
}

export const storeCommunityOrder = (id) => {
    return communities(id) + '/sort';
}

export const detachEntities = (id, params) => {
    return collections(id) + '/detach-entities' + buildUri(params);
}

export const importCommunities = (id) => {
    return collections(id) + '/import-entities';
}

export const collectionProfileSearch = (id, params) => {
    return API_ROOT + COLLECTIONS + id + '/profiles/search' + buildUri(params);
};

export const collectionProfiles = {
    find: (collection_id, profile_id, params) => {
        return API_ROOT + COLLECTIONS + collection_id + '/profiles/' + profile_id + buildUri(params);
    }
}

export default {
    collections,
    collectionReport,
    collectionEntities,
    communities,
    collectionRoles,
    storeCommunityOrder,
    communityChildrens,
    detachEntities,
    importCommunities,
    collectionProfileSearch
}



// WEBPACK FOOTER //
// ./src/api/collections.js